import apiClient from '@/utils/api';

const SESSION_KEY = 'usage_session_id';

// Event names must match backend EVENT_FEATURE_MAP in routes/usage.py
export const USAGE_EVENTS = {
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  VIEW_PAYMENTS: 'VIEW_PAYMENTS',
  UPLOAD_PAYMENT_PROOF: 'UPLOAD_PAYMENT_PROOF',
  DOWNLOAD_RECEIPT: 'DOWNLOAD_RECEIPT',
  VIEW_BENEFICIARIES: 'VIEW_BENEFICIARIES',
  ADD_BENEFICIARY: 'ADD_BENEFICIARY',
  EDIT_BENEFICIARY: 'EDIT_BENEFICIARY',
  VIEW_DOCUMENTS: 'VIEW_DOCUMENTS',
  DOWNLOAD_DOCUMENT: 'DOWNLOAD_DOCUMENT',
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
  VIEW_NOTIFICATIONS: 'VIEW_NOTIFICATIONS',
  VIEW_PROVIDERS: 'VIEW_PROVIDERS',
  VIEW_PROVIDER_DETAIL: 'VIEW_PROVIDER_DETAIL',
};

export const setUsageSession = (sessionId) => {
  if (sessionId) localStorage.setItem(SESSION_KEY, sessionId);
};

export const getUsageSession = () => localStorage.getItem(SESSION_KEY);

export const clearUsageSession = () => localStorage.removeItem(SESSION_KEY);

/**
 * Fire-and-forget usage event tracking. Never throws; analytics must never
 * break the member experience.
 */
export const trackEvent = (event, metadata = null) => {
  try {
    const session_id = getUsageSession();
    apiClient
      .post('/usage/track', { event, session_id, metadata })
      .catch((e) => console.debug('usage track failed', event, e?.message));
  } catch (e) {
    // swallow
  }
};

// Best-effort logout event (awaited so it lands before the token is cleared)
export const trackLogout = async () => {
  try {
    const session_id = getUsageSession();
    await apiClient.post('/usage/track', { event: 'LOGOUT', session_id });
  } catch (e) {
    console.debug('logout track failed', e?.message);
  } finally {
    clearUsageSession();
  }
};
